/*=================================================
    summary: 筆記列表

    remarks: 000 Tim 2021/11/18 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssNoteList from './NoteList.module.scss'

import { FixedSizeList as List } from "react-window"

// import LoadingMask from '../../Windows/LoadingMask'
import {LoadingMask, GlobalLibs, NetworkLibs} from 'bc-react-package'

import NoteDetail from './Units/NoteDetail/NoteDetail'


// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let marrVolumeData = [null, null, null, null]
let mstrDisplayName = ""
let mblnUpdateListContentHeight = false
let mobjShowComponentParam = null
// #endregion Member Variables


const COMP_NAME = "NoteList"

function NoteList(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [bookSeqNo, setBookSeqNo] = useState(0)
    const [listContentHeight, setListContentHeight] = useState(618)

    const [isShowNoteDetail, setIsShowNoteDetail] = useState(false)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    // #endregion Init State

    // #region Init Ref
    let mrefListContent = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    let mrefGetNoteList = useRef(null)
    
    mrefGetNoteList.current = GetNoteList
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        marrVolumeData = [null, null, null, null]
        mstrDisplayName = window.Globals.GetDisplayName()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update updateDataTime
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect updateDataTime")

        if (
            (mblnUpdateListContentHeight) &&
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            mblnUpdateListContentHeight = false
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    }, [updateDataTime])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            marrVolumeData = [null, null, null, null]

            window.removeEventListener('resize', WindowOnResizeEventHandler)

            setBookSeqNo(0)
            setUpdateDataTime(0)
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 Resource 頁面
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowNoteList"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 書本
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function VolumeOnTapHandler(StateBookSeqNo, BookSeqNo)
    {
        console.log(COMP_NAME + ".VolumeOnTapHandler StateBookSeqNo: ", StateBookSeqNo)
        console.log(COMP_NAME + ".VolumeOnTapHandler BookSeqNo: ", BookSeqNo)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateBookSeqNo !== BookSeqNo)
        {
            let intIndex = BookSeqNo - 1

            if (marrVolumeData[intIndex] !== null)
            {
                setBookSeqNo(BookSeqNo)
            }
            else
            {
                mobjCallParam = {
                    "BookCatID": window.gSession.App.BookCatID,
                    "BookSeqNo": BookSeqNo
                }
                GetNoteList()
            }
        }
    } // end of VolumeOnTapHandler
    
    /*===========================================
    summary: 點選 一行
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function SourceUnitOnTapHandler(StateBookSeqNo, VolumeData)
    {
        console.log(COMP_NAME + ".SourceUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjShowComponentParam = {
            "BookSeqNo": StateBookSeqNo,
            "DetailData": VolumeData
        }
        setIsShowNoteDetail(true)
    } // end of SourceUnitOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 改變視窗大小
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function WindowOnResizeEventHandler()
    {
        // console.log(COMP_NAME + ".WindowOnResizeEventHandler")
        
        if (
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    } // end of WindowOnResizeEventHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    // #endregion LoadingMask Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowNoteDetail")
        {
            mobjShowComponentParam = null
            setIsShowNoteDetail(false)
        }
        else if (CallbackObj.Action === "GoToLearningUnit")
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit",
                "LocationState": CallbackObj.LocationState
            }
            props.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "OpenSettings4NoAuthorized")
        {
            let objCallbackData = {
                "Action": "OpenSettings4NoAuthorized",
                "AuthorizedSubscription": CallbackObj.AuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.addEventListener("resize", WindowOnResizeEventHandler)

        mobjCallParam = {
            "BookCatID": window.gSession.App.BookCatID,
            "BookSeqNo": parseInt(window.gSession.App.BookSeqNo)
        }
        GetNoteList()
    } // end of PaintedMe

    /*===========================================
    summary: 取得 最後修改時間
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GetLastModifiedFormate(DateString) 
    {
        // console.log(COMP_NAME + ".GetLastModifiedFormate")

        let datLastModified = new Date(DateString.replace(/-/g, '/'))
        let strLastModified = datLastModified.FormateBCDisplayDate().replace(/-/g, '/')

        // var intYear = datLastModified.getFullYear()
        // var intMonth = datLastModified.getMonth() + 1
        // var intDate = datLastModified.getDate()

        // var strFormatted = ""

        // if (intMonth < 10)
        // {
        //     strFormatted += "0"
        // }
        // strFormatted += intMonth.toString()

        // strFormatted += "/"
        // if (intDate < 10)
        // {
        //     strFormatted += "0"
        // }
        // strFormatted += intDate.toString()

        // strFormatted += "/"
        // strFormatted += intYear.toString()
        

        return strLastModified
    } // end of GetLastModifiedFormate
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 書本按鈕 Cls
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GetVolumeButtonCls(StateBookSeqNo, ButtonSeqNo) 
    {
        let objCls = cssNoteList.btnVolume

        if (StateBookSeqNo === ButtonSeqNo)
        {
            objCls = cssNoteList.btnVolumeSelected
        }

        return objCls
    } // end of GetVolumeButtonCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 取得Note列表資訊 後續流程
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GetNoteListAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetNoteListAfterProcess")

        let intIndex = mobjCallParam.BookSeqNo - 1
        marrVolumeData[intIndex] = ReturnData.NoteList

        console.log(COMP_NAME + ".GetNoteListAfterProcess marrVolumeData: ", marrVolumeData)

        mblnUpdateListContentHeight = true

        setBookSeqNo(mobjCallParam.BookSeqNo)
        setUpdateDataTime(new Date().getTime())

        mobjCallParam = null
    } // end of GetNoteListAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 取得Note列表資訊
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GetNoteList ()
    {
        console.log(COMP_NAME + ".GetNoteList")

        let objRetryFuncRef = GetNoteList
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetNoteListCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetNoteList)

            let objCallData = {
                "Func": "GetNoteList",
                "BookCatID": mobjCallParam.BookCatID,
                "BookSeqNo": mobjCallParam.BookSeqNo
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetNoteList

    /*===========================================
    summary: 取得Note列表資訊 Callback
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetNoteListCallback (Return)
    {
        console.log(COMP_NAME + ".GetNoteListCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetNoteList_No
        let strErrorTitle = window.gAppUI.ERR_GetNoteList_Title
        let strErrMsg = window.gAppUI.ERR_GetNoteList_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetNoteListCallback: ErrNo: ", Return.ErrNo)
            console.log("GetNoteListCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetNoteListCallback Return.Data: ", Return.Data)

            GetNoteListAfterProcess(Return.Data)
        }
    } // end of GetNoteListCallback
    // #endregion Web Service 

    // #region Render元件
    /*===========================================
    summary: Arrow Right Cell 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentArrowRightCell()
    {   
        return(
            <div className={cssNoteList.divArrowRightCell}>
                <div className={cssNoteList.divArrowRightIcon}/>
            </div>
        )
    } // end of ComponentArrowRightCell

    /*===========================================
    summary: Note Msg Cell 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentNoteMsgCell( {NoteBody} )
    {   
        return(
            <div className={cssNoteList.divNoteMsgCell}>
                <div className={cssNoteList.divNoteMsg}>
                    {NoteBody}
                </div> 
            </div>
        )
    } // end of ComponentNoteMsgCell

    /*===========================================
    summary: 最後修改日期 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLastModifiedDate( {LastModifiedTime} )
    {   
        let strDate = GetLastModifiedFormate(LastModifiedTime)
        return(
            <div className={cssNoteList.divLastModifiedDate}>
                {strDate}
            </div>
        )
    } // end of ComponentLastModifiedDate                

    /*===========================================
    summary: Learning Unit Name 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLearningUnitName( {LearningUnitName} )
    {   
        return(
            <div className={cssNoteList.divLearningUnitName}>
                {LearningUnitName}
            </div>
        )
    } // end of ComponentLearningUnitName

    /*===========================================
    summary: Lesson Name 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLessonName( {LessonPrefixText, LessonName} )
    {   
        let strLessonName = LessonPrefixText + "： " + LessonName
        return(
            <div className={cssNoteList.divLessonName}>
                {strLessonName}
            </div>
        )
    } // end of ComponentLessonName

    /*===========================================
    summary: 沒資料的 SourceList 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentSourceList4Empty()
    {   
        return(
            <div className={cssNoteList.divSourceList}>
                <div className={cssNoteList.divEmptyMsg}>
                    {window.gAppUI.MSG_EmptyList_NoNotes}
                </div>   
            </div>
        )
    } // end of ComponentSourceList4Empty

    /*===========================================
    summary: Volume Button 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentVolumeButton( {StateBookSeqNo, BookSeqNo} )
    {   
        let strButton = window.gAppUI.BTN_Volume + " " + BookSeqNo.toString()
        return(
            <div className={GetVolumeButtonCls(StateBookSeqNo, BookSeqNo)} onClick={() => VolumeOnTapHandler(StateBookSeqNo, BookSeqNo)} >
                {strButton}
            </div>
        )
    } // end of ComponentVolumeButton

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
             001 Tim 2022/01/17 將 Close 感應區改大
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssNoteList.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssNoteList.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssNoteList.divTitle}>
                {window.gAppUI.LBL_NoteList}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentDisplayName( {DisplayName} )
    {   
        return(
            <div className={cssNoteList.divDisplayName}>
                {DisplayName}
            </div>
        )
    } // end of ComponentDisplayName
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 檔案下載 書本 資源列表 視窗 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderNoteDetailWrapper(StateIsShowNoteDetail)
    {
        if (StateIsShowNoteDetail)
        {
            return(
                <NoteDetail History={props.History}
                    ButtonType={props.ButtonType}
                    BookSeqNo={mobjShowComponentParam.BookSeqNo}
                    DetailData={mobjShowComponentParam.DetailData}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderNoteDetailWrapper

    /*===========================================
    summary: Render 列表 Lesson Cell 資料內容 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderLessonCellWrapper(VolumeData)
    {
        return (
            <div className={cssNoteList.divLessonCell}>
                <ComponentLessonName LessonPrefixText={VolumeData.LessonPrefixText} LessonName={VolumeData.LessonName} />
                <ComponentLearningUnitName LearningUnitName={VolumeData.LUName} />
                <ComponentLastModifiedDate LastModifiedTime={VolumeData.LastModifiedTime} />
            </div>
        )
    } // end of RenderLessonCellWrapper

    /*===========================================
    summary: Render 列表 資料內容 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderSourceRowWrapper(ListData, StateBookSeqNo)
    {
        let intVolumeIndex = StateBookSeqNo - 1
        let objVolumeData = marrVolumeData[intVolumeIndex][ListData.index]

        return (
            <div className="row" style={ListData.style}>
                <div className={cssNoteList.divSourceUnit} onClick={() => SourceUnitOnTapHandler(StateBookSeqNo, objVolumeData)}>
                    {RenderLessonCellWrapper(objVolumeData)}

                    <ComponentNoteMsgCell NoteBody={objVolumeData.NoteBody} />

                    <ComponentArrowRightCell />
                </div>
            </div>
        )
    } // end of RenderSourceRowWrapper

    /*===========================================
    summary: Render 列表 資料內容 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderSourceListWrapper(StateUpdateDataTime, StateListContentHeight, StateBookSeqNo)
    {
        let intVolumeIndex = StateBookSeqNo - 1
        let arrVolumeData = marrVolumeData[intVolumeIndex]

        if (
            (StateUpdateDataTime > 0) &&
            (arrVolumeData !== null) &&
            (arrVolumeData.length > 0) 
            )
        {      
            return (
                <div className={cssNoteList.divSourceList}>
                    <List width={'100%'} height={StateListContentHeight}
                            itemCount={arrVolumeData.length} itemSize={112}>
                        {(ListData) => RenderSourceRowWrapper(ListData, StateBookSeqNo)}
                    </List>
                </div>
            )
        }
        else
        {
            return (
                <ComponentSourceList4Empty />
            )
        }
    } // end of RenderSourceListWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderContentWrapper(StateBookSeqNo)
    {
        return (
            <div className={cssNoteList.divContent}>
                <div className={cssNoteList.divVolumeTool}>
                    <ComponentVolumeButton StateBookSeqNo={StateBookSeqNo} BookSeqNo={1} />
                    <ComponentVolumeButton StateBookSeqNo={StateBookSeqNo} BookSeqNo={2} />
                    <ComponentVolumeButton StateBookSeqNo={StateBookSeqNo} BookSeqNo={3} />
                    <ComponentVolumeButton StateBookSeqNo={StateBookSeqNo} BookSeqNo={4} />
                </div>

                <div className={cssNoteList.divVolumeToolLine}/>
                
                <div ref={mrefListContent} className={cssNoteList.divListContent}>
                    {RenderSourceListWrapper(updateDataTime, listContentHeight, StateBookSeqNo)}
                </div>
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssNoteList.divTopTool}>
                <ComponentDisplayName DisplayName={mstrDisplayName}/>

                <ComponentTitle />

                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssNoteList.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper(bookSeqNo)}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}

            {RenderNoteDetailWrapper(isShowNoteDetail)}
        </>
    )
    // #endregion Render
}
export default NoteList